import script from "./MyPerfilView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyPerfilView.vue?vue&type=script&setup=true&lang=ts"

import "./MyPerfilView.vue?vue&type=style&index=0&id=3886aa51&scoped=true&lang=postcss"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3886aa51"]])

export default __exports__